import { useState } from 'react'

const AgeVerificationOverlay = ({ onConfirm }) => {
    const [denied, setDenied] = useState(false);

    if (denied) {
        return (
            <div className="overlay-backdrop" id="ageOverlay" style={{ display: 'flex' }}>
                <div className="modal-box">
                    <h2>Access Denied</h2>
                    <p>You must be 21 or older to access this platform.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="overlay-backdrop" id="ageOverlay" style={{ display: 'flex' }}>
            <div className="modal-box">
                <h2>Verification Required</h2>
                <p>Please confirm you are 21 years of age or older to access Aerithal.live premium gaming.</p>
                <div className="modal-btns">
                    <button className="btn btn-primary" id="ageConfirm" onClick={onConfirm}>
                        I am 21 or older
                    </button>
                    <button className="btn btn-secondary" id="ageDeny" onClick={() => setDenied(true)}>
                        Exit Site
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AgeVerificationOverlay